import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import i18nCfg from './i18n/cfg.json';
import extensionTranslations from './i18n/extension.json';
const { ns, lng } = i18nCfg;

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    partialBundledLanguages: true,
    resources: Object.fromEntries(
      Object.entries(extensionTranslations).map(([language, extension]) => [language, { extension }])
    ),
    supportedLngs: lng,
    ns,
    fallbackLng: 'en',
    load: 'currentOnly',
    defaultNS: 'common',
    debug: false,
    lowerCaseLng: false,
    backend: {
      loadPath: `${window.location.origin}/static/locale/{{lng}}/{{ns}}.json`
    },
    interpolation: {
      escapeValue: false
    }
});

export default i18n;
